RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.FileUploadErrorModal = Marionette.ItemView.extend({
        ui: {
            modal: '.modal'
        },
        template: '#fileUploadErrorModalTemplate',
        onRender: function () {
            const me = this;
            me.ui.modal.modal('show');
        }
    });
});
